<template>
    <div>
        <div class=" max-w-5xl mx-auto mt-10">
            <osv-cart-customer widget-options="commercialOffer=false;newsletter=false;additionalRequiredFields=postalCode,phone"/>
        </div>
    </div>
</template>
<script>
export default {

}
</script>

<style lang="scss" scoped>
</style>